import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const SingleProduct = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [count, setCount] = useState(0);

  const [cart, setCart] = useState(
    JSON.parse(localStorage.getItem("cart")) || []
  );

  const addtoCart = () => {
    const existingProduct = cart?.find((product, index) => {
      return product.productId === id;
    });
    if (existingProduct) {
      alert("product already exist!");
    } else {
      setCart((old) => [
        ...old,
        {
          productId: id,
          quantity: count,
        },
      ]);
    }
    navigate("/apitasks/cart");
  };

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [addtoCart]);
  console.log(cart);
  return (
    <div>
      Product Id: {id}
      <button onClick={() => setCount((old) => old + 1)}>Add</button>
      <p>{count}</p>
      <button onClick={() => setCount((old) => old - 1)}>remove</button>
      <button onClick={addtoCart}>Add to cart</button>
    </div>
  );
};

export default SingleProduct;
